import { I } from '@angular/cdk/keycodes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { any } from 'codelyzer/util/function';
import { NgxSpinnerService } from 'ngx-spinner';

import { environment } from '../../../environments/environment';
import { messagefromComponent } from '../../class/appinterface';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { Utenteservice } from '../../services/utente.service';
import { NicaAnagraficaComponent, ToolbarButton } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';

var that:any;


@Component({
  selector: 'app-elencocertrasportabili',
  templateUrl: './elencocertrasportabili.component.html',
  styleUrls: ['./elencocertrasportabili.component.css']
})

export class ElencocertrasportabiliComponent implements OnInit,AfterViewInit  {
  @ViewChild('uElenco', { static: false }) uElenco: NicaAnagraficaComponent;
  @Input() itemData: any
  
  currentIndex=1;
  myFilterStr: any[]=[];
  costantValues: any[]=[];
  idTabRif: number;
  nomeTabRif: any;
  dati: any;
  myEvent:any
  CreateEvent:boolean=false;
  companies= [{
    ID: 1,
    Tipo: 'EER Regime Ordinario',
    Categoria:'O'
  }/*, {
    ID: 2,
    Tipo: "EER c/proprio",
    Categoria:'P'
  }, {
    ID: 3,
    Tipo: "EER 3-BIS",
    Categoria:'3B'
  }, {
    ID: 4,
    Tipo: "EER 4-BIS",
    Categoria:'4B'
  }, {
    ID: 5,
    Tipo: "EER R.MET",   
    Categoria:'RMET'
  },*/]
  PulsantiSuNavBar : ToolbarButton[] =[
    {
      location : 'before' ,
      options : {
        icon : 'paste',
        title : 'Icolla Formato Albo',
        text:'',
        index:1,
        id:"uno",
      }     
    },
    {
      location : 'before' ,
      options : {
        icon : 'trash',
        title : 'Elimina Tutti',
        text:'',
        index:2,
        id:"due"   
      }     
    }

  ]
  AnnullatoInserimento: boolean=false;
  constructor(private usUtente:Utenteservice, private appService: Apiservice,private spinner: NgxSpinnerService,private httpClient:HttpClient,private userComponentService: ComponentService, private _overlaySidePanelService: OverlaySideFormService) { }
  ngAfterViewInit(): void {
    //window.removeEventListener("build",null);
  }

  ngOnInit() {
    that=this;
    //this.userComponentService.castMessage.subscribe((message: messagefromComponent) => this.messaggioFromComponent(message));
    this.myEvent = new Event('build'); 
    //window.removeEventListener("build",null);

    window.addEventListener('build',this.foo,true);

   // window.removeEventListener('build',this.foo,true);

    
    /*/if(!this.usUtente.CreateEvent){
      this.usUtente.CreateEvent=true;
      console.log("Creatooooooooooooo")
      window.addEventListener('build', e => {  
       
        navigator.clipboard.readText().then( text => {
          this.interfacePaste(this.currentIndex,this.companies[this.currentIndex-1].Categoria,text);
        }) 
      },true);
  
    //}*/

   


    if (this.itemData) {     
      this.idTabRif   = this.itemData[0]['idTabRif']
      this.nomeTabRif = this.itemData[0]['nomeTabRif']
      this.dati       = this.itemData[0]['dati']
      this.myFilterStr[1] = '?IdAlbo='+this.idTabRif+"&idTipoIscrizioneAlbo=O";// + this.nomeTabRif + '&IdTabella=' + this.idTabRif
      this.myFilterStr[2] = '?IdAlbo='+this.idTabRif+"&idTipoIscrizioneAlbo=P";
      this.myFilterStr[3] = '?IdAlbo='+this.idTabRif+"&idTipoIscrizioneAlbo=3B";
      this.myFilterStr[4] = '?IdAlbo='+this.idTabRif+"&idTipoIscrizioneAlbo=4B";
      this.myFilterStr[5] = '?IdAlbo='+this.idTabRif+"&idTipoIscrizioneAlbo=RMET";
      this.costantValues[1] =[{value: this.idTabRif,key:'idAlbo'},{value: 'O',key:'idTipoIscrizioneAlbo'}]
      this.costantValues[2] =[{value: this.idTabRif,key:'idAlbo'},{value: 'P',key:'idTipoIscrizioneAlbo'}]
      this.costantValues[3] =[{value: this.idTabRif,key:'idAlbo'},{value: '3B',key:'idTipoIscrizioneAlbo'}]
      this.costantValues[4] =[{value: this.idTabRif,key:'idAlbo'},{value: '4B',key:'idTipoIscrizioneAlbo'}]
      this.costantValues[5] =[{value: this.idTabRif,key:'idAlbo'},{value: 'RMET',key:'idTipoIscrizioneAlbo'}]     
    } 
  }
  public inizializza(): void {
    /**Inizializza Global Var. da funzione pubblica**/
    this.idTabRif   = this.itemData[0]['idTabRif']
    this.nomeTabRif = this.itemData[0]['nomeTabRif']
   // this.myFilterStr[0] = "?nomeTabella=" + this.nomeTabRif + "&IdTabella=" +  this.idTabRif;
    //this.uContatti.refresh();     
  }

  foo(event) {
   
    
    navigator.clipboard.readText().then( text => {
      that.interfacePaste(that.currentIndex,that.companies[that.currentIndex-1].Categoria,text);
    }) 
}

  decodePasteNew(cerPaste,categoria){
    let cerPasteArr=[];
    let cerPasteArrResult=[];

    return new Promise((resolve, reject) => {
      const _asyncCopyFn = (async () => {
      if(!cerPaste.includes(".")){
        alert("errore ne formato  xx.xx.xx - xx.xx.xx");      
        resolve(false);
    }
      if(!cerPaste.includes("-")){   
          let result=cerPaste.replace(/\*/g, '');     
          cerPasteArr=result.split(".");//cerPaste.split(".");
          let idx=-1;
          let mioCer="";
          cerPasteArr.forEach(element => {
              idx++;
              if(element.length==4){
                let currentCer="";
                if(mioCer=="") {
                  currentCer=cerPasteArr[idx-2]+cerPasteArr[idx-1]+element.substring(0,2);
                  mioCer=element.substring(2)
                  cerPasteArrResult.push(currentCer);
                }else {
                  currentCer=mioCer+cerPasteArr[idx-1]+element.substring(0,2);
                  mioCer=element.substring(2)
                  cerPasteArrResult.push(currentCer);
                }
              }
          });
      }else{
        let result=cerPaste.replace(/\./g, '');
        result=result.replace(/\*/g, '');
        result=result.replace(/\ /g, '');
        cerPasteArrResult=result.split("-");
      }
  
  
      let promise=[]
      const value={  
        "id": 0,
        "idAlbo": this.idTabRif,
        "idTipoIscrizioneAlbo": categoria,
        "cer": "",
        "AllCER":cerPasteArrResult
      }
      console.log("SCRIVO I CER ",cerPasteArr)
      const EndPoint=environment.BASE_API_URL+"AlboCer";
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'text');      
      const body=value;
  
      return this.httpClient.post(EndPoint, body,{headers})
      .toPromise()
      .then(response  =>{
        let messaggioChiusura: messagefromComponent = {
          codeMessage: 1,
          destComponent: "grigliacer"+this.currentIndex,
          traceMessage: 'refresh',
          detailsMessage:""
        }
        setTimeout(() => {
          //alert(categoria);
          this.userComponentService.emitMessage(messaggioChiusura); 
          this.spinner.hide();
        }, 200);
          resolve(true)
          console.log(response);
        }) 
      .catch(err=>resolve(false));  
    });
    })
  }

  
  async decodePaste(cerPaste,categoria) {    
    let cerPasteArr=[];
    let cerPasteArrResult=[];

    if(!cerPaste.includes(".")){
      alert("errore ne formato  xx.xx.xx - xx.xx.xx");      
      return;
  }

   

    if(!cerPaste.includes("-")){   
        let result=cerPaste.replace(/\*/g, '');     
        cerPasteArr=result.split(".");//cerPaste.split(".");
        let idx=-1;
        let mioCer="";
        let resultCer="";
        cerPasteArr.forEach(element => {
            idx++;
            if(element.length==2) resultCer+=element;
            if(element.length==4){
              resultCer=element.substring(2)
              let currentCer="";
              if(mioCer=="") {
                currentCer=cerPasteArr[idx-2]+cerPasteArr[idx-1]+element.substring(0,2);
                mioCer=element.substring(2)
                cerPasteArrResult.push(currentCer);
              }else {
                currentCer=mioCer+cerPasteArr[idx-1]+element.substring(0,2);
                mioCer=element.substring(2)
                cerPasteArrResult.push(currentCer);
              }
              
              

            }

        });
        if(resultCer) cerPasteArrResult.push(resultCer);
        
    }else{
      let result=cerPaste.replace(/\./g, '');
      result=result.replace(/\*/g, '');
      result=result.replace(/\ /g, '');
      cerPasteArrResult=result.split("-");
    }


    let promise=[]
    const value={  
      "id": 0,
      "idAlbo": this.idTabRif,
      "idTipoIscrizioneAlbo": categoria,
      "cer": "",
      "AllCER":cerPasteArrResult
    }
    console.log("SCRIVO I CER ",cerPasteArr)
    const EndPoint=environment.BASE_API_URL+"AlboCer";
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'text');      
    const body=value;

    return this.httpClient.post(EndPoint, body,{headers})
    .toPromise()
    .then(response  =>{
      let messaggioChiusura: messagefromComponent = {
        codeMessage: 1,
        destComponent: "grigliacer"+this.currentIndex,
        traceMessage: 'refresh',
        detailsMessage:""
      }
      setTimeout(() => {
        //alert(categoria);
        this.userComponentService.emitMessage(messaggioChiusura); 
        this.spinner.hide();
      }, 200);
      console.log(response)}) 
    .catch();


    cerPasteArr.forEach(element => {
        const value={  
          "id": 0,
          "idAlbo": this.idTabRif,
          "tipo": categoria,
          "cer": element,
          "AllCER":cerPasteArr
        }
        const EndPoint=environment.BASE_API_URL+"AlboCer";
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'text');      
        const body=value;

        return this.httpClient.post(EndPoint, body,{headers})
        .toPromise()
        .then(response  =>response) 
        .catch();




        promise.push(this.httpClient.post(EndPoint, body,{headers})
        .toPromise()
        .then(response  =>response) 
        .catch());
    });
    let res = await Promise.all(promise);
   // console.log(res);
  }
  readClipboardFromDevTools() {
    
    return new Promise((resolve, reject) => {
        const _asyncCopyFn = (async () => {
            try {
              
                navigator.clipboard.readText().then(value=>{
                  resolve(value);
                })
                //const value = await navigator.clipboard.readText();
                //console.log(`${value} is read!`);
                //resolve(value);
            } catch (e) {
                reject(e);
            }
            window.removeEventListener("focus", _asyncCopyFn);
            navigator.clipboard.removeEventListener("focus", _asyncCopyFn);
        });
        
        window.addEventListener("focus", _asyncCopyFn);
        navigator.clipboard.addEventListener("focus", _asyncCopyFn);
        //console.log("Hit <Tab> to give focus back to document (or we will face a DOMException);");
    });
}


interfacePaste(id,categoria,r){
  window.removeEventListener('build',null,true);  
  this.decodePaste(r,categoria).then(value=>{                
    let messaggioChiusura: messagefromComponent = {
      codeMessage: 1,
      destComponent: "grigliacer"+id,
      traceMessage: 'refresh',
      detailsMessage:""
    }
    setTimeout(() => {
      this.userComponentService.emitMessage(messaggioChiusura); 
      this.spinner.hide();
    }, 2000);
  }).catch(alert=>{alert("Non sono riuscito ad incollare")
  this.spinner.hide();
});

}

paste(id,categoria) {   
  window.dispatchEvent(this.myEvent);
  return;

  setTimeout(() => {
    this.spinner.show();
    this.readClipboardFromDevTools().then((r) => 
    {
      console.log("Returned value: ", r)
      
      this.decodePaste(r,categoria).then(value=>{        
        
        let messaggioChiusura: messagefromComponent = {
          codeMessage: 1,
          destComponent: "grigliacer"+id,
          traceMessage: 'refresh',
          detailsMessage:""
        }
        setTimeout(() => {
          this.userComponentService.emitMessage(messaggioChiusura); 
          this.spinner.hide();
        }, 2000);
      

        //alert("Forse ho Finito");
      }).catch(alert=>{alert("Non sono riouscito ad incollare")
      this.spinner.hide();
    });
  }
    //-----------------------------
    );


    
  }, 2000);
return;

     navigator.clipboard.readText().then(cerPaste=>{
      this.spinner.show();
      this.decodePaste(cerPaste,categoria).then(value=>{        
        
        let messaggioChiusura: messagefromComponent = {
          codeMessage: 1,
          destComponent: "grigliacer"+id,
          traceMessage: 'refresh',
          detailsMessage:""
        }
        setTimeout(() => {
          this.userComponentService.emitMessage(messaggioChiusura); 
          this.spinner.hide();
        }, 2000);
      

        //alert("Forse ho Finito");
      });
    
    });
  }
  pippo(event):void{
     this.currentIndex=event.addedItems[0].ID;
    let messaggioChiusura: messagefromComponent = {
      codeMessage: 1,
      destComponent: "grigliacer"+event.addedItems[0].ID,
      traceMessage: 'refresh',
      detailsMessage:""
    }
    setTimeout(() => {
      this.userComponentService.emitMessage(messaggioChiusura); 
    }, 200);
   
    /*
if(message.traceMessage=='refresh'){
        this.griglia.instance.cancelEditData();
        this.griglia.instance.refresh();  
      }
    */
  }
  onAllEvent(e){
    //

    
   
   
    

    if(e.name=="onSaving" ){
     
      //let cer=e.changes[0]['data']['cer'];
      /*
     this.appService.GetApi('Cer/'+cer).then(response=>{
      console.log("Lettoooooooooooo ",response);
      alert(response['descrizione']);
      e.changes[0]['data']['Descrizione'] = response['descrizione'];
     })
        e.changes[0]['data']['allCER']=[];
     */
    }
//
if(e.name=="onRowInserted" ){
  this.AnnullatoInserimento=false;
    console.log("ecco quello che ho inserito ",e)
}
    if(e.name=="onSaved" ){
      this.AnnullatoInserimento=false;
      //e.component.addRow();
      
  }
    //console.log("In Cer Trasportabili ",e);
  }
  
  optionalBottoneToolbar(event){
    //alert(this.currentIndex);
    //alert(this.companies[this.currentIndex-1].Categoria);
    if(event==1)
      this.paste(this.currentIndex,this.companies[this.currentIndex-1].Categoria);
    else
    {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'text');      
      const body={};
      const EndPoint=environment.BASE_API_URL+"AlboCer/DeleteByTipo?idAlbo="+this.idTabRif+"&idTipoIscrizioneAlbo="+this.companies[this.currentIndex-1].Categoria;           
      return this.httpClient.post(EndPoint, body,{headers})
      .toPromise()
      .then(response  =>{        
        let messaggioChiusura: messagefromComponent = {
          codeMessage: 1,
          destComponent: "grigliacer"+this.currentIndex,
          traceMessage: 'refresh',
          detailsMessage:""
        }
        setTimeout(() => {
          this.userComponentService.emitMessage(messaggioChiusura); 
        }, 200);
        console.log(response)}) 
      .catch();
  
    }
    //console.log(event);
  }
}
